/**
 * 入力文字列をサニタイズして、XSS、SQLインジェクション、その他の悪意のあるコードを防ぐ
 * @param input - サニタイズする文字列
 * @returns サニタイズされた文字列
 */
export const sanitizeInput = (input: string): string => {
  if (!input || typeof input !== 'string') {
    return '';
  }

  return input
    // HTMLタグを完全に削除
    .replace(/<[^>]*>/g, '')
    // スクリプトタグの内容も削除
    .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
    // 特殊文字をエスケープ
    .replace(/[<>\"'&]/g, (char) => {
      const escapeMap: { [key: string]: string } = {
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#x27;',
        '&': '&amp;',
      };
      return escapeMap[char];
    })
    // SQL関連のキーワードを削除（大文字小文字を区別しない）
    .replace(/\b(SELECT|INSERT|UPDATE|DELETE|DROP|UNION|WHERE|FROM|CREATE|ALTER|EXEC|EXECUTE|SCRIPT|JAVASCRIPT)\b/gi, '')
    // JavaScriptイベントハンドラを削除
    .replace(/on\w+\s*=/gi, '')
    // 危険なプロトコルを削除
    .replace(/(javascript|vbscript|data):/gi, '')
    // 連続する空白を1つに統一
    .replace(/\s+/g, ' ')
    // 前後の空白を削除
    .trim();
};

/**
 * コメントや長文用のサニタイズ（改行を許可）
 * @param input - サニタイズする文字列
 * @returns サニタイズされた文字列
 */
export const sanitizeTextArea = (input: string): string => {
  if (!input || typeof input !== 'string') {
    return '';
  }

  return input
    // HTMLタグを完全に削除
    .replace(/<[^>]*>/g, '')
    // スクリプトタグの内容も削除
    .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
    // 特殊文字をエスケープ（改行は除外）
    .replace(/[<>\"'&]/g, (char) => {
      const escapeMap: { [key: string]: string } = {
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#x27;',
        '&': '&amp;',
      };
      return escapeMap[char];
    })
    // SQL関連のキーワードを削除（大文字小文字を区別しない）
    .replace(/\b(SELECT|INSERT|UPDATE|DELETE|DROP|UNION|WHERE|FROM|CREATE|ALTER|EXEC|EXECUTE|SCRIPT|JAVASCRIPT)\b/gi, '')
    // JavaScriptイベントハンドラを削除
    .replace(/on\w+\s*=/gi, '')
    // 危険なプロトコルを削除
    .replace(/(javascript|vbscript|data):/gi, '');
    // 注意: trim()は改行も削除するため使用しない
};